module.exports = __webpack_public_path__ + "static/media/118.5817bd56.png";